const n = (o) => typeof o == "string", s = (o) => typeof o == "boolean", r = (o) => typeof o == "number", t = Array.isArray, e = (o) => o === void 0;
export {
  t as isArray,
  s as isBoolean,
  r as isNumber,
  n as isString,
  e as isUndefined
};
